
import React from 'react';
import { useDispatch } from 'react-redux';

import { getIsPermissionsLoaded } from '../../reducers/mysliveckyportal/permissions';
import permissionsGetActions from '../../sagas/mysliveckyportal/userPermissions';

import useAuthToken from './useAuthToken';

export default function useUserPermissions(permissionsState, projectId) {
    const dispatch = useDispatch();
    const permissionsActions = permissionsGetActions(dispatch);

    const token = useAuthToken();
    const isPermissionsLoaded = getIsPermissionsLoaded(permissionsState);

    React.useEffect(() => {
        if (!isPermissionsLoaded && token) {
            permissionsActions.getUserPermissions(token, projectId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPermissionsLoaded, token]);
}
